// extracted by mini-css-extract-plugin
module.exports = {"itemListHeader":"ItemList_itemListHeader__x9Xy4","itemListTitle":"ItemList_itemListTitle__lc503","button":"ItemList_button__1SnRY"};